module.exports = __webpack_public_path__ + "static/media/worship_map_important.3ed4984e.svg";